import { AbstractControl, ValidatorFn } from '@angular/forms';

export function arabicLettersNumbersOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isValid = !control.value || /^[\u0621-\u064A\u0660-\u0669 ]+$/.test(control.value);
    return isValid ? null : { arabicLettersNumbersOnly: true };
  };
}
